export enum DealStepEnum {
    Package = 1,
    Details = 2,
    Payment = 3,
    Terms = 4,
    Approval = 5,
    Welcome = 6
}


// WEBPACK FOOTER //
// ./src/app/_enums/deal-step.enum.ts